import { render, staticRenderFns } from "./register-service-case-form.vue?vue&type=template&id=385c1309&scoped=true&"
import script from "./register-service-case-form.vue?vue&type=script&lang=ts&"
export * from "./register-service-case-form.vue?vue&type=script&lang=ts&"
import style0 from "./register-service-case-form.vue?vue&type=style&index=0&id=385c1309&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385c1309",
  null
  
)

export default component.exports